(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sloan-recipe-discount-popup"]) return;
  try {
    
  (() => {
    const sliceByPrize = { 10: [0, 2, 4, 6], 20: [1, 5], 30: [3], 50: [7] };

    const initialize = (scope = document) => {
      const roots = scope.classList?.contains('sloan-spin')
        ? [scope]
        : scope.querySelectorAll('.sloan-spin:not([data-initialized])');

    roots.forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const discountDialog = root.querySelector('[data-discount-dialog]');
      const discountTrigger = root.querySelector('[data-open-discount]');
      let previousOverflow = '';
      const openDiscount = () => {
        if (discountDialog.open) return;
        previousOverflow = document.body.style.overflow;
        discountDialog.showModal();
        document.body.style.overflow = 'hidden';
        try { sessionStorage.setItem('sloan-recipe-offer-seen-v1', '1'); } catch (_) {}
      };
      discountTrigger.addEventListener('click', openDiscount);
      root.querySelector('[data-close-discount]').addEventListener('click', () => discountDialog.close());
      discountDialog.addEventListener('click', (event) => {
        if (event.target !== discountDialog) return;
        const bounds = discountDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) discountDialog.close();
      });
      discountDialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        discountTrigger.focus({ preventScroll: true });
      });
      let offerSeen = false;
      try { offerSeen = sessionStorage.getItem('sloan-recipe-offer-seen-v1') === '1'; } catch (_) {}
      if (!offerSeen && !window.Shopify?.designMode) {
        setTimeout(() => {
          if (root.isConnected && !document.querySelector('dialog[open]')) openDiscount();
        }, 6000);
      }
      const form = root.querySelector('.sloan-spin__form');
      const wheel = root.querySelector('[data-wheel]');
      const result = root.querySelector('[data-result]');
      const status = root.querySelector('[data-status]');
      const submit = root.querySelector('.sloan-spin__submit');
      const label = root.querySelector('[data-submit-label]');
      const spinButton = root.querySelector('[data-spin-button]');
      const codeArea = root.querySelector('[data-code-area]');
      const prizes = JSON.parse(root.querySelector('[data-sloan-prizes]').textContent);
      const counterStorageKey = `sloan-spin-counts-${location.hostname}-${root.dataset.counterKey || '1'}`;
      let rotation = 0;
      let currentAward = null;
      let spun = false;
      let completed = false;

      const setStatus = (message, isError = false) => {
        status.textContent = message;
        status.style.color = isError ? '#ff9d8e' : '';
      };

      const readCounters = () => {
        try { return JSON.parse(localStorage.getItem(counterStorageKey) || '{}'); }
        catch (_) { return {}; }
      };

      const writeCounters = (counts) => {
        try { localStorage.setItem(counterStorageKey, JSON.stringify(counts)); }
        catch (_) { /* The wheel can still run when browser storage is blocked. */ }
      };

      const chooseAward = () => {
        const counts = readCounters();
        const available = prizes.filter((prize) => {
          const underCap = Number(prize.cap) === 0 || Number(counts[prize.value] || 0) < Number(prize.cap);
          return prize.weight > 0 && prize.code && underCap;
        });
        const total = available.reduce((sum, prize) => sum + prize.weight, 0);
        if (!total) throw new Error('All configured prizes have reached their test limits. Reset the counters in the theme editor.');
        let ticket = Math.random() * total;
        const award = available.find((prize) => ((ticket -= prize.weight) <= 0)) || available[0];
        counts[award.value] = Number(counts[award.value] || 0) + 1;
        writeCounters(counts);
        return award;
      };

      const spinTo = (award) => {
        const choices = sliceByPrize[award.value] || sliceByPrize[10];
        const slice = choices[Math.floor(Math.random() * choices.length)];
        const center = slice * 45;
        rotation += 1800 + (360 - center);
        wheel.style.transform = `rotate(${rotation}deg)`;
        window.setTimeout(() => {
          root.querySelector('[data-prize-value]').textContent = award.value;
          root.querySelector('[data-prize-code]').textContent = award.code;
          result.hidden = false;
          if (discountDialog.open) result.querySelector('input[type="email"]').focus({ preventScroll: true });
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 50 : 4900);
      };

      spinButton.addEventListener('click', () => {
        if (spun) return;
        try {
          currentAward = chooseAward();
          spun = true;
          spinButton.disabled = true;
          spinButton.textContent = '…';
          spinTo(currentAward);
        } catch (error) {
          spinButton.disabled = false;
          spinButton.textContent = 'SPIN';
          window.alert(error.message);
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (completed || !currentAward || !form.reportValidity()) return;
        completed = true;
        submit.disabled = true;
        label.textContent = 'UNLOCKING…';
        setStatus('Adding you to the Sloan kitchen…');

        try {
          const signupResponse = await fetch(form.action, { method: 'POST', body: new FormData(form) });
          if (!signupResponse.ok) throw new Error('We could not save your signup. Please try again.');
          form.hidden = true;
          codeArea.hidden = false;
          codeArea.querySelector('[data-copy-code]').focus({ preventScroll: true });
        } catch (error) {
          completed = false;
          submit.disabled = false;
          label.textContent = 'CLAIM MY CODE';
          setStatus(error.message, true);
        }
      });

      root.querySelector('[data-reset-counters]')?.addEventListener('click', (event) => {
        try { localStorage.removeItem(counterStorageKey); } catch (_) {}
        currentAward = null;
        spun = false;
        completed = false;
        rotation = 0;
        result.hidden = true;
        form.hidden = false;
        form.reset();
        codeArea.hidden = true;
        submit.disabled = false;
        label.textContent = 'CLAIM MY CODE';
        spinButton.disabled = false;
        spinButton.textContent = 'SPIN';
        wheel.style.transition = 'none';
        wheel.style.transform = 'rotate(0deg)';
        requestAnimationFrame(() => { wheel.style.transition = ''; });
        event.currentTarget.textContent = 'COUNTERS RESET ✓';
      });

      root.querySelector('[data-copy-code]').addEventListener('click', async (event) => {
        const code = root.querySelector('[data-prize-code]').textContent;
        try {
          await navigator.clipboard.writeText(code);
          event.currentTarget.querySelector('small').textContent = 'COPIED!';
        } catch (_) {
          event.currentTarget.querySelector('small').textContent = 'SELECT + COPY';
        }
      });

      const flavorButtons = root.querySelectorAll('[data-flavor]');
      const recipeCards = root.querySelectorAll('[data-recipe-flavors]');
      flavorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const flavor = button.dataset.flavor;
          root.querySelector('[data-flavor-results]').hidden = false;
          root.querySelector('.sloan-spin__flavors').hidden = true;
          root.querySelector('[data-choose-flavor]').hidden = false;
          flavorButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          let count = 0;
          recipeCards.forEach((card) => {
            const matches = card.dataset.recipeFlavors.split(' ').includes(flavor);
            card.hidden = !matches;
            card.classList.remove('is-flipped');
            if (matches) count++;
          });
          const selected = button.querySelector('strong')?.textContent || button.textContent;
          root.querySelector('[data-flavor-status]').textContent = selected.trim() + ' · ' + count;
          if (window.matchMedia('(max-width:749px)').matches) {
            root.querySelector('.sloan-spin__recipes').scrollIntoView({ behavior: 'instant', block: 'start' });
          }
        });
      });
      root.querySelector('[data-choose-flavor]').addEventListener('click', () => {
        root.querySelector('[data-flavor-results]').hidden = true;
        root.querySelector('.sloan-spin__flavors').hidden = false;
        root.querySelector('[data-choose-flavor]').hidden = true;
        root.querySelector('[data-flavor-status]').textContent = '';
        root.querySelector('[data-flavor][aria-pressed="true"]')?.focus({ preventScroll: true });
        flavorButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        recipeCards.forEach((card) => card.classList.remove('is-flipped'));
      });
      root.querySelectorAll('[data-flip-card]').forEach((button) => {
        button.addEventListener('click', () => {
          button.closest('.sloan-spin__card').classList.toggle('is-flipped');
        });
      });

      root.querySelectorAll('[data-open-recipe]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = root.querySelector(`#${CSS.escape(button.dataset.openRecipe)}`);
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });

      root.querySelectorAll('.sloan-spin__modal').forEach((dialog) => {
        dialog.querySelector('[data-close-recipe]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.addEventListener('click', async () => {
          const panel = button.closest('.sloan-spin__product-panel');
          const cartStatus = panel.querySelector('[data-cart-status]');
          const variantSelect = panel.querySelector('[data-variant-select]');
          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = 'ADDING…';
          cartStatus.textContent = '';
          try {
            const base = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${base}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantSelect?.value || button.dataset.variantId), quantity: 1 }] })
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(payload.description || 'Could not add this seasoning.');
            button.textContent = 'ADDED ✓';
            cartStatus.innerHTML = `<a href="${base}cart">View your cart →</a>`;
            document.dispatchEvent(new CustomEvent('sloan:cart-updated', { detail: payload }));
          } catch (error) {
            button.disabled = false;
            button.textContent = originalLabel;
            cartStatus.textContent = error.message;
          }
        });
      });
    });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sloan-spin-recipes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliceByPrize = { 10: [0, 2, 4, 6], 20: [1, 5], 30: [3], 50: [7] };

    const initialize = (scope = document) => {
      const roots = scope.classList?.contains('sloan-spin')
        ? [scope]
        : scope.querySelectorAll('.sloan-spin:not([data-initialized])');

    roots.forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('.sloan-spin__form');
      const wheel = root.querySelector('[data-wheel]');
      const result = root.querySelector('[data-result]');
      const status = root.querySelector('[data-status]');
      const submit = root.querySelector('.sloan-spin__submit');
      const label = root.querySelector('[data-submit-label]');
      const spinButton = root.querySelector('[data-spin-button]');
      const codeArea = root.querySelector('[data-code-area]');
      const prizes = JSON.parse(root.querySelector('[data-sloan-prizes]').textContent);
      const counterStorageKey = `sloan-spin-counts-${location.hostname}-${root.dataset.counterKey || '1'}`;
      let rotation = 0;
      let currentAward = null;
      let spun = false;
      let completed = false;

      const setStatus = (message, isError = false) => {
        status.textContent = message;
        status.style.color = isError ? '#ff9d8e' : '';
      };

      const readCounters = () => {
        try { return JSON.parse(localStorage.getItem(counterStorageKey) || '{}'); }
        catch (_) { return {}; }
      };

      const writeCounters = (counts) => {
        try { localStorage.setItem(counterStorageKey, JSON.stringify(counts)); }
        catch (_) { /* The wheel can still run when browser storage is blocked. */ }
      };

      const chooseAward = () => {
        const counts = readCounters();
        const available = prizes.filter((prize) => {
          const underCap = Number(prize.cap) === 0 || Number(counts[prize.value] || 0) < Number(prize.cap);
          return prize.weight > 0 && prize.code && underCap;
        });
        const total = available.reduce((sum, prize) => sum + prize.weight, 0);
        if (!total) throw new Error('All configured prizes have reached their test limits. Reset the counters in the theme editor.');
        let ticket = Math.random() * total;
        const award = available.find((prize) => ((ticket -= prize.weight) <= 0)) || available[0];
        counts[award.value] = Number(counts[award.value] || 0) + 1;
        writeCounters(counts);
        return award;
      };

      const spinTo = (award) => {
        const choices = sliceByPrize[award.value] || sliceByPrize[10];
        const slice = choices[Math.floor(Math.random() * choices.length)];
        const center = slice * 45;
        rotation += 1800 + (360 - center);
        wheel.style.transform = `rotate(${rotation}deg)`;
        window.setTimeout(() => {
          root.querySelector('[data-prize-value]').textContent = award.value;
          root.querySelector('[data-prize-code]').textContent = award.code;
          result.hidden = false;
          result.querySelector('input[type="email"]').focus({ preventScroll: true });
        }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 50 : 4900);
      };

      spinButton.addEventListener('click', () => {
        if (spun) return;
        try {
          currentAward = chooseAward();
          spun = true;
          spinButton.disabled = true;
          spinButton.textContent = '…';
          spinTo(currentAward);
        } catch (error) {
          spinButton.disabled = false;
          spinButton.textContent = 'SPIN';
          window.alert(error.message);
        }
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (completed || !currentAward || !form.reportValidity()) return;
        completed = true;
        submit.disabled = true;
        label.textContent = 'UNLOCKING…';
        setStatus('Adding you to the Sloan kitchen…');

        try {
          const signupResponse = await fetch(form.action, { method: 'POST', body: new FormData(form) });
          if (!signupResponse.ok) throw new Error('We could not save your signup. Please try again.');
          form.hidden = true;
          codeArea.hidden = false;
          codeArea.querySelector('[data-copy-code]').focus({ preventScroll: true });
        } catch (error) {
          completed = false;
          submit.disabled = false;
          label.textContent = 'CLAIM MY CODE';
          setStatus(error.message, true);
        }
      });

      root.querySelector('[data-reset-counters]')?.addEventListener('click', (event) => {
        try { localStorage.removeItem(counterStorageKey); } catch (_) {}
        currentAward = null;
        spun = false;
        completed = false;
        rotation = 0;
        result.hidden = true;
        form.hidden = false;
        form.reset();
        codeArea.hidden = true;
        submit.disabled = false;
        label.textContent = 'CLAIM MY CODE';
        spinButton.disabled = false;
        spinButton.textContent = 'SPIN';
        wheel.style.transition = 'none';
        wheel.style.transform = 'rotate(0deg)';
        requestAnimationFrame(() => { wheel.style.transition = ''; });
        event.currentTarget.textContent = 'COUNTERS RESET ✓';
      });

      root.querySelector('[data-copy-code]').addEventListener('click', async (event) => {
        const code = root.querySelector('[data-prize-code]').textContent;
        try {
          await navigator.clipboard.writeText(code);
          event.currentTarget.querySelector('small').textContent = 'COPIED!';
        } catch (_) {
          event.currentTarget.querySelector('small').textContent = 'SELECT + COPY';
        }
      });

      root.querySelectorAll('[data-flip-card]').forEach((button) => {
        button.addEventListener('click', () => {
          button.closest('.sloan-spin__card').classList.toggle('is-flipped');
        });
      });

      root.querySelectorAll('[data-open-recipe]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = root.querySelector(`#${CSS.escape(button.dataset.openRecipe)}`);
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });

      root.querySelectorAll('.sloan-spin__modal').forEach((dialog) => {
        dialog.querySelector('[data-close-recipe]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        button.addEventListener('click', async () => {
          const panel = button.closest('.sloan-spin__product-panel');
          const cartStatus = panel.querySelector('[data-cart-status]');
          const variantSelect = panel.querySelector('[data-variant-select]');
          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = 'ADDING…';
          cartStatus.textContent = '';
          try {
            const base = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${base}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantSelect?.value || button.dataset.variantId), quantity: 1 }] })
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(payload.description || 'Could not add this seasoning.');
            button.textContent = 'ADDED ✓';
            cartStatus.innerHTML = `<a href="${base}cart">View your cart →</a>`;
            document.dispatchEvent(new CustomEvent('sloan:cart-updated', { detail: payload }));
          } catch (error) {
            button.disabled = false;
            button.textContent = originalLabel;
            cartStatus.textContent = error.message;
          }
        });
      });
    });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
